<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-form-item label="排序" prop="sort">
                <el-input v-model="form.sort" placeholder="请输入排序" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item label="上传图片" prop="image">
                <Uploader :sizeLimit="1024 * 1024 * 2" v-model="form.image" tip="建议尺寸为640*384像素，大小小于2M"></Uploader>
            </el-form-item>
            <el-form-item label="跳转类型" prop="url_type">
                <el-radio-group v-model="form.url_type">
                    <el-radio label="1">富文本</el-radio>
                    <el-radio label="2">指定商品</el-radio>
                    <el-radio label="3">解决方案</el-radio>
                    <el-radio label="4">站外链接</el-radio>
                    <el-radio label="5">站内链接</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="富文本详情" prop="text" v-if="form.url_type == 1">
                <Editor v-model="form.text"></Editor>
            </el-form-item>
            <el-form-item label="选择商品" prop="goods_cuuid" v-if="form.url_type == 2">
                <el-button @click="handleGoodsPick" style="width: 300px">请选择</el-button>
                <el-tag closable @close="handleGoodsClose" style="margin-left: 10px" v-if="goods.cuuid">{{ goods.name }}</el-tag>
            </el-form-item>
            <el-form-item label="选择方案" prop="mcase_cuuid" v-if="form.url_type == 3">
                <el-button @click="handlePlanPick" style="width: 300px">请选择</el-button>
                <el-tag closable @close="handlePlanClose" style="margin-left: 10px" v-if="plan.cuuid">{{ plan.name }}</el-tag>
            </el-form-item>
            <el-form-item label="url地址" prop="url" v-if="form.url_type == 4">
                <el-input v-model="form.url" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item label="链接位置" prop="page_position" v-if="form.url_type == 5">
                <el-select v-model="form.page_position" style="width: 300px">
                    <el-option label="产品中心" value="1"></el-option>
                    <el-option label="领券大厅" value="2"></el-option>
                    <el-option label="购买渠道" value="3"></el-option>
                    <el-option label="关于我们" value="4"></el-option>
                    <el-option label="解决方案主页" value="5"></el-option>
                    <el-option label="杰锐德故事主页" value="6"></el-option>
                    <el-option label="个人中心主页" value="7"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" style="width: 120px" @click="handleConfirm">确定</el-button>
                <el-button style="width: 120px" @click="$router.back()">取消</el-button>
            </el-form-item>
        </el-form>
        <GoodsPicker ref="goods" @pick="goodsPick"></GoodsPicker>
        <PlanPicker ref="plan" @pick="planPick"></PlanPicker>
    </div>
</template>

<script>
import Uploader from "@/components/Uploader";
import Editor from "@/components/Editor";
import GoodsPicker from "@/components/GoodsPicker";
import PlanPicker from "@/components/PlanPicker";
import { add, edit, detail } from "@/api/content/banner";
export default {
    components: { Uploader, Editor, GoodsPicker, PlanPicker },
    data() {
        return {
            form: {
                url_type: "1",
                status: "1",
                page_position: undefined,
            },
            goods: {},
            plan: {},
            rules: {
                image: [{ required: true, message: "请上传图片" }],
            },
        };
    },
    mounted() {
        this.form.uuid = this.$route.query.uuid;
        if (this.form.uuid) {
            this.getDetail();
        }
    },
    methods: {
        getDetail() {
            detail({ uuid: this.form.uuid }).then(({ code, result, error }) => {
                if (code === 200) {
                    this.form = result || {};
                    this.form.page_position = this.form.page_position == "0" ? undefined : this.form.page_position;
                    this.plan.cuuid = this.form.mcase_cuuid;
                    this.plan.name = this.form.mcase_name;
                    this.goods.cuuid = this.form.goods_cuuid;
                    this.goods.name = this.form.goods_name;
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleGoodsPick() {
            this.$refs.goods.open();
        },
        handlePlanPick() {
            this.$refs.plan.open();
        },
        goodsPick(data) {
            this.goods = data;
        },
        planPick(data) {
            this.plan = data;
        },
        handleGoodsClose() {
            this.goods = {};
        },
        handlePlanClose() {
            this.plan = {};
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    ...this.form,
                    goods_cuuid: this.goods.cuuid,
                    mcase_cuuid: this.plan.cuuid,
                };
                if (this.form.uuid) {
                    edit(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("修改成功");
                            this.$router.back();
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                } else {
                    add(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("新增成功");
                            this.$router.back();
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                }
            });
        },
    },
};
</script>

<style></style>
